import React from 'react';
import clsx from 'clsx';
import LoadingSpinner from './LoadingSpinner';
import styles from './LoadingOverlay.module.css';

export interface LoadingOverlayProps {
  variant?: 'global' | 'modal' | 'page' | 'container';
  message?: string;
  showSpinner?: boolean;
  className?: string;
  dataTestId?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  variant = 'page',
  message,
  showSpinner = true,
  className,
  dataTestId
}) => {
  return (
    <output
      className={clsx(
        styles.overlay,
        {
          [styles.overlayGlobal]: variant === 'global',
          [styles.overlayModal]: variant === 'modal',
          [styles.overlayPage]: variant === 'page',
          [styles.overlayContainer]: variant === 'container'
        },
        className
      )}
      data-test-id={dataTestId}
      aria-label={message || 'Loading'}
    >
      <div className={styles.spinnerContainer}>
        {showSpinner && <LoadingSpinner size="medium" />}
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </output>
  );
};

export default LoadingOverlay;
